export const MAX_UPLOAD_SIZE = 25 * 1024 * 1024; // 25mb in bytes
export const MAX_FILES_COUNT = 20;
